import { EmptyState } from "./EmptyState";
import { PageHead } from "./PageHead";
import type { IconName } from "./Icon";

type Props = {
  title: string;
  subtitle?: string;
  icon?: IconName;
  description?: string;
};

/** On-brand placeholder for screens whose backend module isn't built yet. */
export function ComingSoon({ title, subtitle, icon = "sparkles", description }: Props) {
  return (
    <>
      <PageHead title={title} subtitle={subtitle} />
      <EmptyState
        icon={icon}
        size="lg"
        title="Em breve"
        description={
          description ??
          "Este módulo será habilitado quando o backend correspondente for entregue."
        }
      />
    </>
  );
}
